import Insider from '../src/Insider/index.tsx';
export default Insider;
